import { Button, Card, Checkbox, Col, Flex, Form, Layout, Row, Typography } from 'antd';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import iconTitle from '../../assets/images/schedules/agent-seat-icon.svg';
import iconDriver from '../../assets/images/schedules/icon-driver.svg';
import iconExtraDriver from '../../assets/images/schedules/icon-extra-driver.svg';
import '../../assets/styles/scheduleSetting.scss';
import StepSchedules from '../../components/StepSchedules';
import { Constant } from '../../config/constant';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { ListScheduleSelector, setAgentSeat, setUpdateAgentSeat } from '../../redux/slice/schdules/scheduleSlice';

export enum ScheduleType {
  specific_date = 'specific_date',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  days = 'days',
}

function AgentSeatSetting() {
  const dispatch = useAppDispatch();
  const {
    listSegment,
    listSeatMap,
    agent_seats,
    isDetailSchedule,
    listScheduleDetail,
    isUpdatedAgentSeat,
    idSeatMap,
    dataSchedule,
  } = useAppSelector(ListScheduleSelector);
  const [form] = Form.useForm();
  const agentSeatWatch = Form.useWatch('agent_seats', form);
  const navigate = useNavigate();

  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      form.scrollToField(firstErrorField.name);
    }
  };
  const getClassNameBgCard = (type: number, name?: string) => {
    if (!type) {
      return '';
    } else {
      if (type <= 2) {
        return 'bg-driver';
      } else {
        if (agentSeatWatch?.includes(name)) {
          return 'bg-active';
        }
      }
    }
  };
  const toggleSeatSelection = (seatName: string, seatType: number) => {
    if (seatName && seatType > Constant.EXTRA_DRIVER_SEAT) {
      const currentSeats = form.getFieldValue('agent_seats') || [];
      const updatedSeats = currentSeats.includes(seatName)
        ? currentSeats.filter((seat: any) => seat !== seatName)
        : [...currentSeats, seatName];
      form.setFieldsValue({ agent_seats: updatedSeats });
    }
  };
  const onFinish = (values: any) => {
    dispatch(setAgentSeat(values.agent_seats));
    navigate('/bus-management/schedules/prices');
    if (isDetailSchedule) {
      dispatch(setUpdateAgentSeat(true));
    }
  };
  useEffect(() => {
    if (agent_seats?.length) {
      form.setFieldValue('agent_seats', agent_seats);
    }
  }, [agent_seats]);

  useEffect(() => {
    if (isDetailSchedule && !isUpdatedAgentSeat) {
      if (listScheduleDetail?.bus_type?.id !== idSeatMap) {
        form.setFieldValue('agent_seats', listSeatMap?.seats);
      } else {
        form.setFieldValue('agent_seats', listScheduleDetail?.agent_seats);
      }
    }
  }, [isDetailSchedule, isUpdatedAgentSeat, listScheduleDetail, idSeatMap]);

  useEffect(() => {
    if (dataSchedule?.frequency_type && !dataSchedule?.is_diagram) {
      form.setFieldsValue({ agent_seats: listSeatMap?.seats });
    }
  }, [dataSchedule, listSeatMap]);
  return (
    <Layout className="min-vh-70 segment-booking schedule schedule-modal">
      <Card>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          validateTrigger="onSubmit"
          name="segment-setting-form"
          colon={false}
          labelCol={{ span: 12 }}
          labelAlign={'left'}
          labelWrap
          onFieldsChange={(allFields) => {
            scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
          }}
          initialValues={{ agent_seats: listSeatMap?.seats?.length ? listSeatMap?.seats : [] }}
        >
          <StepSchedules step={4} />
          <div className="segment-block">
            <div className="mt-4 border-b-segment pb-3">
              <Flex gap={16}>
                <img src={iconTitle} alt="" />
                <div>
                  <Typography.Text className="fw-600 fs-18 title-segment">Mở bán cho đại lý</Typography.Text> <br />
                  <Typography.Text className="fw-500 fs-16" style={{ color: '#4F5662' }}>{`Tuyến: ${
                    listSegment?.depart_point ?? ''
                  } - ${listSegment?.arrive_point ?? ''}, Giờ đi: ${listSegment?.depart_time}`}</Typography.Text>
                </div>
              </Flex>
            </div>
            <div className="agent-seat-content mt-4 w-fit">
              <p className="fs-16 fw-500" style={{ color: '#4F5662' }}>
                {'Số lượng mở bán: '}
                <span className="text-success">{agentSeatWatch?.length ? agentSeatWatch?.length : 0}</span>
              </p>
              {dataSchedule?.frequency_type && dataSchedule?.is_diagram ? (
                <>
                  {agentSeatWatch?.length > 0 && agentSeatWatch?.length === listSeatMap?.seats?.length ? (
                    <Button
                      className="fs-16 fw-600  text-cancel border-none mt-3"
                      style={{ paddingLeft: 0 }}
                      onClick={() => {
                        form.setFieldsValue({ agent_seats: [] });
                      }}
                    >
                      Hủy chọn
                    </Button>
                  ) : (
                    <Button
                      className="fs-16 fw-600 text-success border-none mt-3"
                      style={{ paddingLeft: 0 }}
                      onClick={() => {
                        form.setFieldsValue({ agent_seats: listSeatMap?.seats });
                      }}
                    >
                      Chọn tất cả
                    </Button>
                  )}
                </>
              ) : (
                ''
              )}
              {listSeatMap[`floor1`] && (
                <Flex gap={28} className="mt-3">
                  <div className="seat-floor-1">
                    <div className="btn-floor">
                      <p>Tầng 1</p>
                    </div>
                    {listSeatMap[`floor1`]?.map((rowSeats: any, rowIndex: number) => {
                      return (
                        <Row key={rowIndex} gutter={[8, 8]} style={{ columnGap: '8px' }}>
                          {rowSeats?.map((seatFloors: any, colIndex: number) => {
                            return (
                              <Col
                                key={colIndex}
                                className={`mh-76 mw-70 d-flex items-center justify-content-center ${
                                  seatFloors?.name ? 'card-agent-seat' : ''
                                } ${getClassNameBgCard(seatFloors?.type, seatFloors?.name)} `}
                              >
                                <Button
                                  className="w-100 h-100 p-0 border-none bg-transparent"
                                  disabled={dataSchedule?.frequency_type && !dataSchedule?.is_diagram}
                                  onClick={() =>
                                    dataSchedule?.frequency_type &&
                                    dataSchedule?.is_diagram &&
                                    toggleSeatSelection(seatFloors?.name, seatFloors?.type)
                                  }
                                >
                                  {seatFloors?.type === Constant.DRIVER_SEAT ? (
                                    <img src={iconDriver} alt="" />
                                  ) : seatFloors?.type === Constant.EXTRA_DRIVER_SEAT ? (
                                    <img src={iconExtraDriver} alt="" />
                                  ) : (
                                    seatFloors?.name
                                  )}
                                </Button>
                              </Col>
                            );
                          })}
                        </Row>
                      );
                    })}
                  </div>
                  {listSeatMap?.count_floor === 2 ? (
                    <div className="seat-floor-2">
                      <div className="btn-floor floor2">
                        <p>Tầng 2</p>
                      </div>
                      {listSeatMap[`floor2`]?.map((rowSeats: any, rowIndex: number) => {
                        return (
                          <Row key={rowIndex} gutter={[8, 8]} style={{ columnGap: '8px' }}>
                            {rowSeats?.map((seatFloors: any, colIndex: number) => {
                              return (
                                <Col
                                  key={colIndex}
                                  className={`mh-76 mw-70 d-flex items-center justify-content-center ${
                                    seatFloors?.name ? 'card-agent-seat' : ''
                                  } ${getClassNameBgCard(seatFloors?.type, seatFloors?.name)}`}
                                >
                                  <Button
                                    className="w-100 h-100 p-0 border-none bg-transparent"
                                    disabled={dataSchedule?.frequency_type && !dataSchedule?.is_diagram}
                                    onClick={() =>
                                      dataSchedule?.frequency_type &&
                                      dataSchedule?.is_diagram &&
                                      toggleSeatSelection(seatFloors?.name, seatFloors?.type)
                                    }
                                  >
                                    {seatFloors?.type === Constant.DRIVER_SEAT ? (
                                      <img src={iconDriver} alt="" />
                                    ) : seatFloors?.type === Constant.EXTRA_DRIVER_SEAT ? (
                                      <img src={iconExtraDriver} alt="" />
                                    ) : (
                                      seatFloors?.name
                                    )}
                                  </Button>
                                </Col>
                              );
                            })}
                          </Row>
                        );
                      })}
                    </div>
                  ) : (
                    ''
                  )}
                </Flex>
              )}
            </div>
            <Form.Item name="agent_seats" className="form-item-name required mt-4 d-none">
              <Checkbox.Group className="" options={listSeatMap?.seats} />
            </Form.Item>
          </div>
        </Form>
      </Card>
    </Layout>
  );
}

export default AgentSeatSetting;
